/**
 * Eroare si vechime de date.
 *
 * Regula din plan: la esec valoarea RAMANE, cu chip `Nesalvat` + `Reincearca`; niciodata spinner
 * blocant, niciodata modal de salvare. Iar datele invechite se anunta cu ORA lor — „ultima
 * actualizare" fara ora e exact informatia care nu ajuta pe nimeni la 9 dimineata.
 */

import type { ReactNode } from 'react';

const oraFmt = new Intl.DateTimeFormat('ro-RO', {
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Europe/Bucharest',
});

export interface PropsErrorState {
  titlu?: string;
  /** Mesajul tehnic, vizibil (ascunderea lui costa un email de suport). */
  detaliu?: ReactNode;
  onReincearca?: () => void;
  className?: string;
}

export function ErrorState({
  titlu = 'Nu am putut încărca datele',
  detaliu,
  onReincearca,
  className,
}: PropsErrorState) {
  return (
    <div
      className={`flex flex-col items-center gap-3 px-4 py-10 text-center ${className ?? ''}`}
      role="alert"
    >
      <span data-stare="blocked" className="pastila">
        eroare
      </span>
      <p className="text-16 font-medium text-ink-1">{titlu}</p>
      {detaliu ? (
        <p className="max-w-prose text-12 text-ink-2">{detaliu}</p>
      ) : null}
      {onReincearca ? (
        <button type="button" className="hit-24 chip font-medium text-ink-1" onClick={onReincearca}>
          Reîncearcă
        </button>
      ) : null}
    </div>
  );
}

/** Banner de date invechite: „Date de la 14:32 · Reincarca". */
export function StaleBanner({
  actualizatLa,
  onReincarca,
  className,
}: {
  /** Epoch ms al ultimei incarcari reusite. */
  actualizatLa: number;
  onReincarca: () => void;
  className?: string;
}) {
  return (
    <div
      className={`flex items-center gap-2 border-b border-hairline bg-sticky px-3 py-1 text-11 text-ink-2 ${className ?? ''}`}
      role="status"
    >
      <span data-stare="waiting" className="pastila">
        vechi
      </span>
      <span>
        Date de la <span className="num">{oraFmt.format(new Date(actualizatLa))}</span>
      </span>
      <span aria-hidden="true">·</span>
      <button type="button" className="hit-24 chip" onClick={onReincarca}>
        Reîncarcă
      </button>
    </div>
  );
}

/** Chip de mutatie nereusita, folosit inline in celula: valoarea rmne, salvarea se reia. */
export function ChipNesalvat({ onReincearca }: { onReincearca: () => void }) {
  return (
    <span className="inline-flex items-center gap-1">
      <span data-stare="urgent" className="pastila">
        Nesalvat
      </span>
      <button type="button" className="hit-24 chip" onClick={onReincearca}>
        Reîncearcă
      </button>
    </span>
  );
}
